import { Link } from 'react-router-dom';
import withLinkNavItem from './withLinkNavItem';
export default withLinkNavItem(Link);
//# sourceMappingURL=LinkNavItem.js.map